import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeFormFieldSkeleton } from './TypeFormField';

export interface TypeFormFields {
    id: EntryFieldTypes.Symbol;
    intro?: EntryFieldTypes.Text;
    fields: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeFormFieldSkeleton>>;
    successMessage?: EntryFieldTypes.Text;
    submitButtonText?: EntryFieldTypes.Symbol;
    formErrorMessage?: EntryFieldTypes.Text;
}

export type TypeFormSkeleton = EntrySkeletonType<TypeFormFields, 'form'>;
export type TypeForm<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeFormSkeleton,
    Modifiers,
    Locales
>;

export function isTypeForm<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeForm<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'form';
}
